<ng-container
  *transloco="let t; read: 'calculator_result.charts.roi-chart'">
  <psc-section-title
    [title]="t('title')"
    alignment="left"
    size="normal"
    [lineWidthPercentage]="100"
    [lineThickness]="2"></psc-section-title>
  <div class="w-[100%] flex justify-center">
    <canvas baseChart class="chart limited-max-height"
            [data]="moneyChartData"
            [options]="moneyChartOptions"
            [type]="moneyChartType"></canvas>
  </div>

  <div class="-ml-[5000px] absolute">
    <canvas baseChart class="chart limited-max-height"
            [width]="resultChartsService.chartWidth"
            [height]="resultChartsService.chartForPdfHeight"
            [data]="moneyChartData"
            [options]="moneyChartOptions"
            [type]="moneyChartType"></canvas>
  </div>
</ng-container>
